import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "allowedStatus",
    "button",
    "confirmation",
    "countdownStatus",
    "initialStatus",
    "pluralUnit",
    "seconds",
    "singularUnit"
  ]
  static values = {
    delaySeconds: { type: Number, default: 10 },
    title: String
  }

  connect() {
    this.resetCountdown()
    this.validate()
  }

  disconnect() {
    this.clearTimer()
  }

  validate() {
    if (this.confirmationTarget.value === this.titleValue) {
      this.startCountdown()
    } else {
      this.resetCountdown()
    }
  }

  startCountdown() {
    if (this.timer || !this.buttonTarget.disabled) return

    this.deadline = Date.now() + (this.delaySecondsValue * 1000)
    this.showStatus(this.countdownStatusTarget)
    this.timer = window.setInterval(() => this.updateCountdown(), 250)
    this.updateCountdown()
  }

  updateCountdown() {
    const secondsRemaining = Math.max(
      0,
      Math.ceil((this.deadline - Date.now()) / 1000)
    )

    if (secondsRemaining === 0) {
      this.clearTimer()
      this.buttonTarget.disabled = false
      this.showStatus(this.allowedStatusTarget)
    } else {
      this.secondsTarget.textContent = secondsRemaining
      this.singularUnitTarget.hidden = secondsRemaining !== 1
      this.pluralUnitTarget.hidden = secondsRemaining === 1
    }
  }

  resetCountdown() {
    this.clearTimer()
    this.buttonTarget.disabled = true
    this.showStatus(this.initialStatusTarget)
  }

  clearTimer() {
    if (!this.timer) return

    window.clearInterval(this.timer)
    this.timer = null
  }

  showStatus(statusTarget) {
    this.initialStatusTarget.hidden = statusTarget !== this.initialStatusTarget
    this.countdownStatusTarget.hidden = statusTarget !== this.countdownStatusTarget
    this.allowedStatusTarget.hidden = statusTarget !== this.allowedStatusTarget
  }
}
